module.exports = __webpack_public_path__ + "img/Priest-dwarf-m-60.d6056662.gif";